import { CoffeeMakerIcon } from './CoffeeMakerIcon';

/**
 * author: Google
 * id 62F4C783-4BE1-4EB6-B454-E41A50B91857
 * name coffee-maker
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/coffee-maker.svg
 * tags
 * - Home Automation 
 * - Food / Drink 
 */
export const EspressoMakerIcon = CoffeeMakerIcon;
export default EspressoMakerIcon